import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Affix } from 'antd';
import { AuditOutlined, BookOutlined, FileZipOutlined } from '@ant-design/icons';
import { Button as MuiButton } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { submitEmployeeInfo } from '../../api';
import useApplicationSession from '../../session/UserSession';
import { useHistory, useLocation } from 'react-router-dom';
import { SUBSCRIPTION_INFO, SUBSCRIPTION_IDENTIFICATION } from '../../route/AppRouter';
import road from '../../assets/images/road.svg';
import car from '../../assets/images/car.svg';

const EmployeeForm = ({ value }) => {
    const { register, handleSubmit, setError, errors, setValue } = useForm();
    const [isEdit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const token = useApplicationSession();
    const history = useHistory();
    const location = useLocation();
    const onSubmit = (data) => {
        setLoading(true);
        if (isEdit) {
            submitEmployeeInfo({ token: token, request: data })
                .then((response) => {
                    onNext();
                })
                .catch((error) => {
                    if (error.errors) {
                        const nameArr = Object.keys(error.errors);
                        nameArr.forEach((key) => {
                            setError(key, 'notMatch', error.errors[key][0]);
                        });
                    }
                    setLoading(false);
                });
        } else {
            // next({ employee: data });
        }
    };

    useEffect(() => {
        if (value !== null) {
            const values = [];
            const keys = Object.keys(value);
            keys.forEach((key) => {
                values.push({ [key]: value[key] });
            });
            // values.push({previous_length_of_employement: "2"})
            setValue(values);
        } else {
            // for new user
            setEdit(true);
        }
    }, [value, setValue]);

    // const handleEdit = () => {
    //   setEdit(!isEdit);
    // };

    const onNext = () => {
        history.push({
            pathname: `${SUBSCRIPTION_IDENTIFICATION}`,
            search: location.search,
        });
    };

    const onPrevious = () => {
        history.push({
            pathname: `${SUBSCRIPTION_INFO}`,
            search: location.search,
        });
    };

    return (
        <div className="formStatus">
            <form
                test_id="subscription-employee-form"
                className="payment-information-form"
                onSubmit={handleSubmit(onSubmit)}
            >
                {/* -------- emploee info start --------*/}
                <div className="payment-information-label-container">
                    <AuditOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Employment History</h4>
                </div>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-employee-name"
                            disabled={isEdit}
                            name="employer_name"
                            type="text"
                            label="Employer Name"
                            placeholder="Enter Employer Name"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 2,
                                    message: 'Employer Name must be minimum 2 character.',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.employer_name?.type === 'required' && (
                                <span className="formFieldError">Please enter employer name.</span>
                            )}
                            {errors.employer_name?.type === 'minLength' && (
                                <span className="formFieldError">{errors.employer_name.message}</span>
                            )}
                            {errors.employer_name?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.employer_name?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-occupation-position"
                            disabled={isEdit}
                            name="occupation_position"
                            type="text"
                            label="Occupation/Position"
                            placeholder="Enter Occupation/Position"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 2,
                                    message: 'Occupation/Position must be minimum 2 character.',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.occupation_position?.type === 'required' && (
                                <span className="formFieldError">Please enter your occupation/position.</span>
                            )}
                            {errors.occupation_position?.type === 'minLength' && (
                                <span className="formFieldError">{errors.occupation_position.message}</span>
                            )}
                            {errors.occupation_position?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.occupation_position?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-monthly-income"
                            disabled={isEdit}
                            name="monthly_income"
                            type="number"
                            min="0"
                            step="0"
                            label="Current Salary (Monthly/Aunnual)"
                            placeholder="Enter Current Salary"
                            register={register({ required: true, maxLength: 15 })}
                        />
                        <div className="form-error">
                            {errors.monthly_income?.type === 'required' && (
                                <span className="formFieldError">Please enter monthly income.</span>
                            )}
                            {errors.monthly_income?.type === 'maxLength' && (
                                <span className="formFieldError">Invalid income rate.</span>
                            )}
                            {errors.monthly_income?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.monthly_income?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-length-of-employment"
                            disabled={isEdit}
                            name="length_of_employment"
                            type="text"
                            label="Length of Employement"
                            placeholder="Enter Length of Employement"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.length_of_employment && (
                                <span className="formFieldError">Please enter length of employement.</span>
                            )}
                            {errors.length_of_employment?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.length_of_employment?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-industry"
                            disabled={isEdit}
                            name="industry"
                            type="text"
                            label="Industry(e.g. Banking, legal, medical, etc.)"
                            placeholder="Enter Industry"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 2,
                                    message: 'Industry must be minimum 2 character.',
                                },
                                maxLength: {
                                    value: 50,
                                    message: 'Industry must be maximun 50 character.',
                                },
                            })}
                        />
                        {/* <h4 className="payment-information-label">Employment History</h4> */}
                        <div className="form-error">
                            {errors.industry?.type === 'required' && (
                                <span className="formFieldError">Please enter industry.</span>
                            )}
                            {errors.industry?.type === 'minLength' && (
                                <span className="formFieldError">{errors.industry?.message}</span>
                            )}
                            {errors.industry?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.industry?.message} </span>
                            )}
                            {errors.industry?.type === 'maxLength' && (
                                <span className="formFieldError"> {errors.industry?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-employee-address"
                            disabled={isEdit}
                            name="address"
                            type="text"
                            label="Employer Address"
                            placeholder="Enter Employer Address"
                            rows={8}
                            register={register({
                                required: true,
                                minLength: 3,
                            })}
                        />
                        <div className="form-error">
                            {errors.address?.type === 'required' && (
                                <span className="formFieldError">Please enter employer address.</span>
                            )}
                            {errors.address?.type === 'minLength' && (
                                <span className="formFieldError">Length of character must be at least 3.</span>
                            )}
                            {errors.address?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.address?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                {/* -------- emploee info end --------*/}

                {/* -------- approval person start --------*/}
                <div className="payment-information-label-container">
                    <BookOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Approval Person</h4>
                </div>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-manager-name"
                            disabled={isEdit}
                            name="manager_name"
                            type="text"
                            label="Manager Name"
                            placeholder="Enter Manager Name"
                            register={register({
                                required: true,
                                minLength: 3,
                            })}
                        />
                        <div className="form-error">
                            {errors.manager_name?.type === 'required' && (
                                <span className="formFieldError">Please enter manager name.</span>
                            )}

                            {errors.manager_name?.type === 'minLength' && (
                                <span className="formFieldError">Manager Name must be minimum 3 character.</span>
                            )}
                            {errors.manager_name?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.manager_name?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-manager-email"
                            disabled={isEdit}
                            name="manager_email"
                            type="text"
                            label="Manager Email"
                            placeholder="Enter Manager Email"
                            register={register({
                                required: true,
                                pattern:
                                    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            })}
                        />
                        <div className="form-error">
                            {errors.manager_email?.type === 'required' && (
                                <span className="formFieldError">Please enter manager email.</span>
                            )}
                            {errors.manager_email?.type === 'pattern' && (
                                <span className="formFieldError">Please enter valid email format.</span>
                            )}
                            {errors.manager_email?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.manager_email?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-manager-contact-number"
                            disabled={isEdit}
                            name="manager_contact_number"
                            type="number"
                            min="0"
                            step="0"
                            label="Manager Phone"
                            placeholder="Enter manager phone"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 6,
                                    message: 'Manager phone must be minimum 6 digits.',
                                },
                                maxLength: {
                                    value: 13,
                                    message: 'Manager phone must be maximun 13 digits.',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.manager_contact_number?.type === 'required' && (
                                <span className="formFieldError">Please enter manager phone.</span>
                            )}
                            {errors.manager_contact_number?.type === 'minLength' && (
                                <span className="formFieldError">{errors.manager_contact_number.message}</span>
                            )}
                            {errors.manager_contact_number?.type === 'maxLength' && (
                                <span className="formFieldError">{errors.manager_contact_number.message}</span>
                            )}
                            {errors.manager_contact_number?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.manager_contact_number?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-employee-manager-address"
                            disabled={isEdit}
                            name="manager_address"
                            type="text"
                            label="Manager Address"
                            placeholder="Enter Manager Address"
                            rows={8}
                            register={register({ required: true, minLength: 3 })}
                        />
                        <div className="form-error">
                            {errors.manager_address?.type === 'required' && (
                                <span className="formFieldError">Please enter manager address.</span>
                            )}
                            {errors.manager_address?.type === 'minLength' && (
                                <span className="formFieldError">Manager Address must be minimum 3 character.</span>
                            )}
                            {errors.manager_address?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.manager_address?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>
                {/* -------- approval person end --------*/}

                {/* -------- pervious work start --------*/}
                <div className="payment-information-label-container">
                    <FileZipOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Previous Work</h4>
                </div>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-previous-employer_name"
                            disabled={isEdit}
                            name="previous_employer_name"
                            type="text"
                            label="Previous Employer Name"
                            placeholder="Enter previous employer name"
                            register={register({
                                required: false,
                                // minLength: {
                                //   value: 3,
                                //   message: "Previous employer name must be minimum 3 character. .",
                                // },
                            })}
                        />
                        <div className="form-error">
                            {errors.previous_employer_name?.type === 'required' && (
                                <span className="formFieldError">Please enter pervious employer name.</span>
                            )}
                            {errors.previous_employer_name?.type === 'minLength' && (
                                <span className="formFieldError">{errors.previous_employer_name.message}</span>
                            )}
                            {errors.previous_employer_name?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.previous_employer_name?.message} </span>
                            )}
                        </div>
                    </Col>

                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-previous_occupation_position"
                            disabled={isEdit}
                            name="previous_occupation_position"
                            type="text"
                            label="Previous Occupation/Position"
                            placeholder="Enter Occupation/Position"
                            register={register({ required: false })}
                        />
                        <div className="form-error">
                            {errors.previous_occupation_position?.type === 'required' && (
                                <span className="formFieldError"> Please enter previous occupation/position. </span>
                            )}
                            {errors.previous_occupation_position?.type === 'minLength' && (
                                <span className="formFieldError">
                                    Previous occupation/position must be minimum 3 character.
                                </span>
                            )}
                            {errors.previous_occupation_position?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.previous_occupation_position?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-employee-previous_address"
                            disabled={isEdit}
                            name="previous_address"
                            type="text"
                            label="Previous Employer Address"
                            placeholder="Enter Previous Employer Address"
                            rows={8}
                            register={register({ required: false })}
                        />
                        <div className="form-error">
                            {errors.previous_address?.type === 'required' && (
                                <span className="formFieldError">Please enter previous employer address.</span>
                            )}
                            {errors.previous_address?.type === 'minLength' && (
                                <span className="formFieldError">
                                    Previous employer address must be minimum 3 character.
                                </span>
                            )}
                            {errors.previous_address?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.previous_address?.message} </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-employee-previous_length_of_employment"
                            disabled={isEdit}
                            name="previous_length_of_employment"
                            type="text"
                            label="Previous Length of Employement"
                            placeholder="Enter Length of Employement"
                            register={register({ required: false })}
                        />
                        <div className="form-error">
                            {errors.previous_length_of_employment && (
                                <span className="formFieldError">Please enter previous length of employement.</span>
                            )}
                        </div>
                    </Col>
                </Row>
                {/* -------- pervious work end --------*/}
                <div className="subscriptionContentContainerSteps">
                    <MuiButton onClick={() => onPrevious()} className="secondary-btn profilePrev">
                        back
                    </MuiButton>
                    <Button
                        test_id="subscription-employee-submit"
                        loading={loading}
                        className="secondary-btn profileNext"
                        htmlType="submit"
                    >
                        NEXT
                    </Button>
                </div>
            </form>

            <Affix offsetBottom={0}>
                <div className="formStepper">
                    <img src={car} alt="Car" className="formStepperCar step3" />
                    <img src={road} alt="Road" className="formStepperRoad" />
                </div>
            </Affix>
        </div>
    );
};

EmployeeForm.propTypes = {
    next: PropTypes.func.isRequired,
    previous: PropTypes.func.isRequired,
};

export default EmployeeForm;
